/* customized for KLP */
class Header extends HTMLElement {
  constructor () {
    super()
  }
  connectedCallback () {
    ;(this.mobile_nav_menu = document.querySelector('.mobile-nav--menu')),
      (this.mobile_nav_banner = this.querySelector('.mobile-nav--banner')),
      (this.y_menu = this.querySelector('.y-menu')),
      (this.country_selector = this.querySelector('.header--country-selector')),
      this.moveYMenu(),
      theme.settings.transitions && theme.transitions.reload('y-menu'),
      Shopify.designMode && this.sectionListeners();

      var thiss = this;
      //this.classList.toggle("scrolled-down", window.scrollY > 50);    
      document.on('scroll.Header', (event) => {
        //window.console.log('scrollY=' + window.scrollY + ', scrollTop=' + document.documentElement.scrollTop + ', pageYOffset=' + window.pageYOffset);

        thiss.classList.toggle("scrolled-down", window.scrollY > 50);
      });
  }
  disconnectedCallback () {
    document.off('scroll.Header');
  }
  moveYMenu () {
    ;(this.mobile_nav_menu.innerHTML = ''),
      this.mobile_nav_menu &&
        this.mobile_nav_banner &&
        this.mobile_nav_menu.appendChild(this.mobile_nav_banner),
      this.mobile_nav_menu &&
        this.y_menu &&
        this.mobile_nav_menu.appendChild(this.y_menu);
    if (this.mobile_nav_menu && this.country_selector) {
        var clone = this.country_selector.cloneNode(true);
        this.mobile_nav_menu.appendChild(clone);
    }
  }
  sectionListeners () {
    this.on('theme:section:load', () => theme.drawer.loadTriggers())
  }
}
customElements.define('header-root', Header)
